export function BlueWalletIcon() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="17"
        height="17"
        fill="none"
        viewBox="0 0 17 17"
      >
        <path
          stroke="#0767F4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.004"
          d="M7.198 11.287v1.36c0 1.15-1.071 2.081-2.39 2.081-1.32 0-2.397-.93-2.397-2.082v-1.359c0 1.152 1.071 1.968 2.397 1.968 1.319 0 2.39-.823 2.39-1.968z"
        ></path>
        <path
          stroke="#0767F4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.004"
          d="M7.197 9.446c0 .335-.094.643-.255.91-.395.65-1.205 1.058-2.142 1.058-.937 0-1.747-.415-2.142-1.058a1.756 1.756 0 01-.255-.91c0-.576.268-1.091.697-1.466.435-.382 1.03-.61 1.693-.61a2.59 2.59 0 011.694.61c.442.368.71.89.71 1.466z"
        ></path>
        <path
          stroke="#0767F4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.004"
          d="M7.198 9.446v1.841c0 1.151-1.071 1.968-2.39 1.968-1.32 0-2.397-.823-2.397-1.968V9.446c0-1.151 1.071-2.082 2.397-2.082a2.59 2.59 0 011.693.61c.429.374.697.896.697 1.472zM14.728 7.344v1.379c0 .368-.295.67-.67.683h-1.312c-.723 0-1.386-.53-1.446-1.252-.04-.422.12-.817.402-1.091.248-.255.59-.402.964-.402h1.392c.375.013.67.315.67.683z"
        ></path>
        <path
          stroke="#0767F4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.004"
          d="M1.339 7.03V5.69c0-1.82 1.098-3.093 2.805-3.307.174-.027.355-.04.542-.04h6.025c.174 0 .342.007.502.033 1.727.201 2.845 1.48 2.845 3.314v.971h-1.392c-.375 0-.716.147-.964.402-.281.274-.442.67-.402 1.09.06.724.723 1.253 1.446 1.253h1.312v.97c0 2.009-1.338 3.348-3.347 3.348H9.038"
        ></path>
      </svg>
    );
  }